export default "__VITE_ASSET__$64lJUpf__"